export const environment = {
  endpoint: 'https://api-stg.sanantonio.digital/',
  production: false,
  storage: 'san_antonio',
  title: 'San Antonio Digital',
  googleApi: 'AIzaSyBM9e9__TVACstA4Be9DVzSsX89l9jrKPk',
  googleLimit: 128,
};
